import { Lock } from 'lucide-react';

export interface SubmitFooterValidationMessagesProps {
  isReadOnly: boolean;
  isDaily: boolean;
  entriesCount: number;
  hasMissingProjects: boolean;
  hasMissingDescriptions: boolean;
  hasMissingCostCentres: boolean;
  hasMissingRoles: boolean;
  hasBlockingPolicyViolation: boolean;
}

/** Validation hints shown on the left of the submit footer. */
export function SubmitFooterValidationMessages({
  isReadOnly,
  isDaily,
  entriesCount,
  hasMissingProjects,
  hasMissingDescriptions,
  hasMissingCostCentres,
  hasMissingRoles,
  hasBlockingPolicyViolation,
}: SubmitFooterValidationMessagesProps) {
  if (isReadOnly) return null;

  return (
    <>
      {entriesCount === 0 && (
        <p className="text-xs text-muted-foreground truncate">Add at least one timesheet entry to submit</p>
      )}
      {entriesCount > 0 && hasMissingProjects && (
        <p className="text-xs text-destructive truncate">Please select a project for all entries before submitting</p>
      )}
      {entriesCount > 0 && !hasMissingProjects && hasMissingDescriptions && !isDaily && (
        <p className="text-xs text-destructive truncate">Please add descriptions to all entries before submitting</p>
      )}
      {entriesCount > 0 && !hasMissingProjects && hasMissingDescriptions && isDaily && (
        <p className="text-xs text-destructive truncate">Please add daily descriptions to all entries before submitting</p>
      )}
      {entriesCount > 0 && !hasMissingProjects && hasMissingCostCentres && (
        <p className="text-xs text-destructive truncate">Please add a cost centre to all entries before submitting</p>
      )}
      {entriesCount > 0 && !hasMissingProjects && !hasMissingCostCentres && hasMissingRoles && (
        <p className="text-xs text-destructive truncate">Please add roles to all entries before submitting</p>
      )}
      {hasBlockingPolicyViolation && (
        <p className="text-xs text-destructive flex items-center gap-1 truncate">
          <Lock className="h-3 w-3 flex-shrink-0" />
          Submission blocked by policy — review AI Insights for details
        </p>
      )}
    </>
  );
}
